import { inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { BaseService } from '@shared/core';
import { map, Observable } from 'rxjs';
import {
  IDeviceConfig,
  IDeviceDiagnostics,
  IDeviceItem,
  IDeviceParams,
  IDevicePayload,
  IDeviceResponseModel,
  IDeviceTestConnectionResult,
  IInventoryImportResult,
  ITestDeviceConnectionCommand,
} from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/devices';

  getAllDevices(filter?: IDeviceParams): Observable<IDeviceResponseModel> {
    return this.http.getWithHeaders(this.apiUrl, filter).pipe(
      map(res => ({
        items: res.body ?? [],
        total: Number(res.headers.get('X-Pagination-Total') ?? 0),
      })),
    );
  }

  getDeviceById(id: string): Observable<IDeviceItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  setDevice(payload: IDevicePayload): Observable<unknown> {
    return this.http.post(this.apiUrl, payload);
  }

  updateDeviceById(id: string, payload: IDevicePayload): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteDevice(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }

  /** GET {id}/config (право devices:manage) — пароль наружу НИКОГДА. */
  getDeviceConfig(id: string): Observable<IDeviceConfig> {
    return this.http.get(this.apiUrl + '/' + id + '/config');
  }

  /** POST test-connection (право devices:manage). */
  testConnection(body: ITestDeviceConnectionCommand): Observable<IDeviceTestConnectionResult> {
    return this.http.post(this.apiUrl + '/test-connection', body);
  }

  /** GET {id}/diagnostics (право devices:view) — поллить 1с только при открытой карточке. */
  getDiagnostics(id: string): Observable<IDeviceDiagnostics> {
    return this.http.get(this.apiUrl + '/' + id + '/diagnostics');
  }

  /**
   * POST import — тело СЫРОЙ YAML (text/plain), parkingLotId и dryRun в query.
   * (права devices:manage + cameras:manage).
   */
  importInventory(
    yaml: string,
    parkingLotId: string,
    dryRun: boolean,
  ): Observable<IInventoryImportResult> {
    return this.http.post(this.apiUrl + '/import', yaml, {
      params: { parkingLotId, dryRun },
      headers: new HttpHeaders({ 'Content-Type': 'text/plain' }),
    });
  }

  /** GET export — YAML-текст без секретов (права devices:view + cameras:view). */
  exportInventory(parkingLotId: string): Observable<string> {
    return this.http.get(this.apiUrl + '/export', { parkingLotId }, 'text');
  }
}
